import { render, staticRenderFns } from "./FeatureFlagList.vue?vue&type=template&id=a351072c&"
import script from "./FeatureFlagList.vue?vue&type=script&lang=js&"
export * from "./FeatureFlagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports